<template>
    <div class="type-box" v-if="match.sportType === '足球'">
        <!-- 赛事数据 -->
        <div class="activity-football-list" v-if="data1.matchTeamGameCount">
          <div class="card">
            <p>赛事数据 <span @click="goStats">更多</span></p>
          </div>
          <div class="content">
            <div class="box">
              <div class="football-team-Introduction">
                <img :src="filterImage(match.icon,80,80)">
                <div>
                  <p>赛事进球统计</p>
                  <span>{{filterDate(match.beginDate,'yyy.MM.DD')}}-{{filterDate(match.endDate,'yyy.MM.DD')}}</span>
                </div>
              </div>
              <div class="data-show">
                <p>{{ data1.matchTeamGameCount }}<span>场次</span></p>
                <p>{{ data1.matchTeamGoalCount }}<span>总进球数</span></p>
                <p>{{ (data1.avgMatchTeamGoalCount).toFixed(1) }}<span>场均进球</span></p>
              </div>
            </div>
          </div>
        </div>
        <div class="activity-football-list" v-if="data2.matchTeamGameCount">
          <div class="card">
            <p>球队数据 <span>更多</span></p>
          </div>
          <div class="content">
            <div class="box">
              <div class="football-team-Introduction">
                <img :src="filterImage(match.icon, 80, 80)">
                <div>
                  <p>赛事进球统计</p>
                  <span>{{ filterDate(match.beginDate, 'yyy.MM.DD') }}-{{ filterDate(match.endDate, 'yyy.MM.DD') }}</span>
                </div>
              </div>
              <div class="data-show">
                <p>{{ data2.matchTeamGameCount }}<span>场次</span></p>
                <p>{{ data2.matchTeamGoalCount }}<span>总进球数</span></p>
                <p>{{ (data2.avgMatchTeamGoalCount).toFixed(1) }}<span>场均进球</span></p>
              </div>
            </div>
          </div>
        </div>
        <!-- 最佳射手 -->
        <div class="card bot" v-if="result.shooter">最佳射手</div>
        <div class="champion-list mvp" v-if="result.shooter">
          <div class="left-img">
            <span>{{ result.shooter && result.shooter.trueName }}</span>
            <img src="@/assets/images/teamNo1.png" class="no-2">
          </div>
          <div class="right">
            <p>{{ result.shooter && result.shooter.name}}</p>
            <p class="aceShooter-dl">总进球 &nbsp;&nbsp; {{ result.shooter && result.shooter.goalCount }}</p>
          </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { Icon } from 'vant'
import { QNImageUtil } from '@/utils'
import Moment from 'moment'
// import teams from './TeamList'
Vue.use(Icon)
export default {
  props: {
    match: {
      typeof: Object,
      default: {}
    },
    result: {
      typeof: Object,
      default: () => {}
    },
    data1: {},
    data2: {},
  },
  methods: {
    filterDate(date, i) {
      return Moment(date).format(i)
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    goPages(id) {
      this.$router.push({ path: 'match-detail', query: { matchId: id } })
    },
    goStats() {
      if (process.env.NODE_ENV === 'development') {
        window.location.href = `https://www.snsports.cn/webapp-stage/main.html#/match-stats?matchId=${this.match.id}`
      } else {
        window.location.href = `https://www.snsports.cn/webapp/main.html#/match-stats?matchId=${this.match.id}`
      }
    }
  }
}
</script>

<style scoped lang="scss">
p{
  margin: 0;
}
 .type-box{
    margin-top: 10px;
    .champion-list{
      padding: 10px 20px 10px 0;
      margin-bottom: 10px;
      background-color: #fff;
      display: flex;
      align-items: center;
      .left-img{
        width: 106px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
          width: 60px;
          height: 60px;
        }
        .no-1{
          width: 68px;
          height: 38px;
          margin-top: -13px;
        }
      }
      .right{
        border-left: 2px solid #f2f2f2;
        flex: 1;
        padding-left: 10px;
        .tr1{
          font-size: 16px;
          margin: 0;
          margin-bottom: 5px;
          span{
            font-size: 14px;
            margin: 0 15px 0 25px;
          }
        }
        & div:nth-child(2){
          span{
            background-color: #38906B;
          }
        }
        & div:nth-child(3){
          span{
            background-color: #0D7096;
          }
        }
        & div:nth-child(4){
          span{
            background-color: #CF2F30;
          }
        }
        .tr2{
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 5px;
          div{
            min-width: 85%;
            width: 85%;
            height: 6px;
            background-color: #F3F3F3;
            margin: 0 10px;
            span{
              width: 0;
              display: block;
              height: 100%;
              border-radius: 1px;
              transition: width 0.5s ease;
            }
          }
        }
      }
    }
    .activity-football-list{
      margin-top: 10px;
      .card{
        p{
          margin: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span{
            color: rgb(171, 171, 171);
            font-size: 12px;
          }
        }
      }
      .content{
        background-color: #fff;
        padding: 12px 20px;
        .box{
          background-color: #F8F8F8;
          border-radius: 2px;
          padding: 15px 0;
          .football-team-Introduction{
            padding: 15px;
            display: flex;
            align-items: center;
            img{
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 10px;
              background-color: #0aa;
            }
            div{
              font-size: 0;
              p{
                font-size: 14px;
                font-weight: 600;
              }
              span{
                font-size: 12px;
                color: #9B9B9B;
              }
            }
          }
          .data-show{
            font-size: 26px;
            padding-top: 10px;
            padding-bottom: 5px;
            color: #191919;
            display: flex;
            justify-content: space-around;
            span{
              font-size: 12px;
              color: #9B9B9B;
            }
          }
        }
      }
    }
    .mvp{
      font-size: 16px;
      .aceShooter-dl{
        font-size: 14px;
        color: #464646;
        margin-top: 5px;
      }

      .no-2{
        width: 34px !important;
        height: 25px !important;
      }
    }
  }
.card {
  background-color: #fff;
  font-size: 16px;
  padding: 12px 20px;
}
.bot{
  border-bottom: 2.5px solid #F8F8F8;
}
.overflow-text{
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
</style>
